const PLATFORM_META = {
  facebook: { label: "Facebook", icon: "fab fa-facebook-f", color: "#1877f2" },
  instagram: { label: "Instagram", icon: "fab fa-instagram", color: "#e4405f" },
  linkedin: { label: "LinkedIn", icon: "fab fa-linkedin-in", color: "#0a66c2" },
  google: { label: "Google", icon: "fab fa-google", color: "#4285f4" },
  tiktok: { label: "TikTok", icon: "fab fa-tiktok", color: "#010101" },
  "tiktok-business": { label: "TikTok Business", icon: "fab fa-tiktok", color: "#010101" },
  youtube: { label: "YouTube", icon: "fab fa-youtube", color: "#ff0000" },
  pinterest: { label: "Pinterest", icon: "fab fa-pinterest-p", color: "#bd081c" },
  twitter: { label: "Twitter", icon: "fab fa-twitter", color: "#1da1f2" }
};

export function normalizePlatform(platform) {
  return String(platform || "").trim().toLowerCase();
}

export function getPlatformMeta(platform) {
  const key = normalizePlatform(platform);
  return (
    PLATFORM_META[key] || {
      label: key ? key.charAt(0).toUpperCase() + key.slice(1) : "Social",
      icon: "fas fa-share-alt",
      color: "#6c757d"
    }
  );
}

export function accountOptionKey(account) {
  return `${normalizePlatform(account.platform)}::${account.accountId}`;
}

export function accountDisplayName(account) {
  const meta = getPlatformMeta(account.platform);
  return account.accountName || meta.label;
}

export function uniquePlatformsFromAccounts(accounts) {
  const platforms = new Set();
  for (const account of accounts || []) {
    const platform = normalizePlatform(account.platform);
    if (platform) platforms.add(platform);
  }
  return Array.from(platforms);
}

export const PREVIEW_PLATFORM_ICONS = [
  "fab fa-facebook-f",
  "fab fa-linkedin-in",
  "fab fa-tiktok",
  "fab fa-pinterest-p",
  "fab fa-instagram",
  "fab fa-google",
  "fab fa-youtube"
];
